import { render, staticRenderFns } from "./HondaDisclosure.vue?vue&type=template&id=6d05d358&"
import script from "./HondaDisclosure.vue?vue&type=script&lang=js&"
export * from "./HondaDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports